import React from "react";
import { Link } from "react-router-dom";

class Page10 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 10) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0 d-md-block">Learning Points</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
            </nav>

            <div className="container-fluid h-100 vertical-center ">
              <div className="row h-100 justify-content-center">
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div className="card mb-4 box-shadow" id="pageContent">
                    <div className="card-body d-flex flex-column text-dark">
                      <span id="moduleContentText_2">
                        <p>
                          <ol>
                            <li>
                              Don’t worry if you do not find your dream career
                              or job role straightaway – exploring the world of
                              work is a process – even Steve Jobs spent 10 years
                              “in the wilderness”.
                            </li>
                            <br />
                            <li>
                              It’s a question of experimentation as you test
                              your values and strengths against different roles
                              and learn from those experiences.
                            </li>
                            <br />
                            <li>
                              Take action and do something, especially if you
                              have some ideas. Find some work experience, talk
                              to professionals in careers which interest you or
                              attend careers fairs. Give the next module{" "}
                              <Link to="/Module2" target="_blank">
                                'I have some ideas but need to focus my
                                thinking'
                              </Link>{" "}
                              a go.
                            </li>
                          </ol>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page10;
